import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loading: false,
        breadcrumbs: [],
        historyRoutes: {}
    },
    getters: {
    },
    mutations: {
        setLoading (state, payload) {
            if (state.loadingBounce) {
                clearTimeout(state.loadingBounce)
            }

            if (payload) {
                state.loading = payload
            } else {
                state.loadingBounce = setTimeout(() => {
                    state.loading = payload
                }, 200)
            }
        },

        // Breadcrumbs
        setBreadcrumbs (state, breadcrumbs) {
            state.breadcrumbs = breadcrumbs
        },
        addHistoryRoute (state, route) {
            state.historyRoutes[route.name] = route
        }
    },
    actions: {
        setLoading ({ commit }, payload) {
            commit('setLoading', payload)
        },
        // Breadcrumbs
        setBreadcrumbs ({ commit }, payload) {
            commit('setBreadcrumbs', payload)
        },
        addHistoryRoute ({ commit }, payload) {
            commit('addHistoryRoute', payload)
        }
    }
})
